/* Header Height Js */
//var p_height = $(".site-header").outerHeight();

/*$(document).ready(function(){
  $("body").css('padding-top', p_height);
});

$(window).resize(function(){
  $("body").css('padding-top', p_height);
});
*/
/*
(function(){
  let variantId = document.querySelector("[name='id']").value;

  if (!history.replaceState || !variantId) {
    return;
  }

  var newurl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      '?variant=' +
      variantId;
  window.history.replaceState({ path: newurl }, '', newurl);
})();
*/

$(document).ready(function(){
   $(document).on("click",".open-size-guide", function(){
    console.log("open");
    document.getElementById('id01').style.display='block';
    $("body").addClass("size-guide-open");
  });

  setInterval(function(){
    if($(".size-guide-open").length != 0){
      if(document.getElementById('id01').style.display != 'block'){
        $("body").removeClass("size-guide-open");
      }
    }
  },100);

  handleSizePopup();

  function handleSizePopup(){
    //product page tabclick js
    $('.size-table').hide();
    $(".size-popup-wrap").on('click',function(){
      $('.product-desk-wrap').hide();
      $(this).addClass("active");
      $('.description-link').removeClass("active");
      $('.size-table').show();
      $("body").addClass("size-guide-open");
    });

    $(".first-tab").on('click',function(){
      $('.size-table').hide();
      $(this).addClass("active");
      $('.size-popup-wrap').removeClass("active");
      $('.product-desk-wrap').show();
    });
  }


  if ( $('body').find("#product_tags_dropdown").length ) {
    $('body').addClass('color-varient-available'); // Make main anchor  also selected
  }

  $('.site-header__cart').on('click', function(){
    $('.side-cart-main-wrap').toggleClass('open-side-cart');
    $('.side-cart-main-wrap').parent().toggleClass('open-side-cart');
    $('body').toggleClass('open-side-cart');
  });

  document.addEventListener('liquid-ajax-cart:request-end', event => {
    const {requestState} = event.detail;
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
      $('.side-cart-main-wrap').addClass('open-side-cart');
      $('.side-cart-main-wrap').parent().addClass('open-side-cart');
      $('body').addClass('open-side-cart');
    }
  });

  $('.side-cart-overly-wrap, .close-icon').on('click', function(event){
    if ( $(event.target).hasClass('side-cart-overly-wrap') || $(event.target).hasClass('close-icon') ) {
      $('.open-side-cart').removeClass('open-side-cart');
    }
  });

  $('.send-to-btn').on('click', function(){
    $('.side-cart-body-wrap-2').addClass('open-side-cart-body-wrap-2');
  });
  $('.side-cart-body-wrap-2 .back-to-shipping-link').on('touchend click', function(event){
    if ( $(event.target).hasClass('back-to-shipping-link') ) {
      $('.open-side-cart-body-wrap-2').removeClass('open-side-cart-body-wrap-2');
    }
  });

  $('.genrate-link').on('click', function(){
    $('.side-cart-body-wrap-3').addClass('open-side-cart-body-wrap-3');
    generateLink(); // defined on aja-cart.js
  });
  $('.side-cart-body-wrap-3 .back-to-shipping-link').on('touchend click', function(event){
    if ( $(event.target).hasClass('back-to-shipping-link') ) {
      $('.open-side-cart-body-wrap-3').removeClass('open-side-cart-body-wrap-3');
    }
  });



});


$(window).scroll(function(){

  // Add parallax scrolling to all images in .paralax-image container
  $('.parallax-image').each(function(){
    // only put top value if the window scroll has gone beyond the top of the image
    if ($(this).offset().top < $(window).scrollTop()) {
      // Get ammount of pixels the image is above the top of the window
      var difference = $(window).scrollTop() - $(this).offset().top;
      // Top value of image is set to half the amount scrolled
      // (this gives the illusion of the image scrolling slower than the rest of the page)
      var half = (difference / 2) + 'px',
          transform = 'translate3d( 0, ' + half + ',0)';

      $(this).find('img').css('transform', transform);
    } else {
      // if image is below the top of the window set top to 0
      $(this).find('img').css('transform', 'translate3d(0,0,0)');
    }
  });
});


// $(function(){  // $(document).ready shorthand
//   $('.more-product-wrap').fadeIn('slow');
// });
setTimeout(function(){
  $(document).ready(function() {

    /* Every time the window is scrolled ... */
    $(window).scroll( function(){

      /* Check the location of each desired element */
      $('.template-index .home-collection-list .more-product-wrap').each( function(i){

        var bottom_of_object = $(this).position().top + $(this).outerHeight();
        var bottom_of_window = $(window).scrollTop() + $(window).height();

        /* If the object is completely visible in the window, fade it it */
        if( bottom_of_window > bottom_of_object ){

          $(this).animate({'opacity':'1'},1000);

        }

      });

    });

  });
}, 300);
// var current_url = window.location.href;
// var str2 = "products";
// if(current_url.indexOf(str2) != -1){
//   $(function() {
//     var menu = $('.product-form-product-template');
//     var hieghtThreshold = $("#MainContent").offset().top;
//     var hieghtThreshold_end  = $("#MainContent").offset().top +$("#MainContent").height();
//     $(window).scroll(function() {
//       var scroll = $(window).scrollTop() + 100;

//       if (scroll >= hieghtThreshold && scroll <=  hieghtThreshold_end ) {
//         menu.addClass('sticky_add_to_cart');
// //         $('body').addClass('main_sticky_add_to_cart');
//       } else {
//         menu.removeClass('sticky_add_to_cart');
// //         $('body').removeClass('main_sticky_add_to_cart');
//       }
//     });
//   })
// }

Theme = {

  GeneralJS: function(){
    var p_height = $(".site-header").outerHeight();
    //     $("body").css('padding-top', p_height);
  },

  //=== Menu ===================================================

  MenuJS: function(){
    $(".site-header__menu").click(function(){
      $("body").toggleClass("open-menu");
    });
  },

  //   collection: function(a){
  //     var top = 0;
  //     var main = $(a);
  //     var randomClass = ( 'eH' + Math.random() ).replace('.','');
  //     // console.log('A random class: ' + randomClass); // ?
  //     main.each( function() {

  //       var distanceFromTop = $(this).offset().top;
  //       // console.log('This is ' + distanceFromTop + ' from the top.');

  //       if ( distanceFromTop > top ) {
  //         $('.' + randomClass).removeClass(randomClass);
  //         top = distanceFromTop;
  //         // console.log('"top" is ' + top + 'px away');
  //       }

  //       $(this).addClass(randomClass);

  //       $(this).css('min-height','auto');

  //       var newHeight = (Math.max.apply(null, $('.' + randomClass).map( function() {
  //         return $(this).outerHeight();
  //       }).get()));

  //       $('.' + randomClass).css('min-height',newHeight);

  //     }).removeClass(randomClass);

  //   },

  DesktopheightJS: function(){
    var p_height = $(".product-card__image-wrapper");
    $(document).ready(function(){

      //var h1height = 0;
      var h1height;
      p_height.each(function() {
        if(h1height < $(this).outerHeight()){
          h1height = $(this).outerHeight();
        };
      });
      p_height.css('height', h1height);
    });
  },

  MobileheightJS: function(){
    var width = $(window).innerWidth();
    var p_height = $(".product-card__image-wrapper");

    if(p_height.length){
      if (p_height.width() != width) {
        width = p_height.width();
        p_height.removeAttr('style');
        var h1height;
        p_height.each(function() {
          if(h1height < $(this).outerHeight()){
            h1height = $(this).outerHeight();
          };
        });
        p_height.css('height', h1height);
      }
    }


  },

  DesktopMENU: function(){
    var windowheight = $(window).scrollTop();
    var windowSize = $(window).width();

    if (windowSize >= 768) {
      if(windowheight > 150){
        //$('.desktop__show_hide').css('visibility', 'visible');
        $('.site-header').addClass('visible__logo_color');
        $('.site-header__mobile-nav').addClass('visible__logo_color');
      }else{
        //$('.desktop__show_hide').css('visibility', 'hidden');
        $('.site-header').removeClass('visible__logo_color');
        $('.site-header__mobile-nav').removeClass('visible__logo_color');
      }
    }

    if (windowSize < 768) {
      if(windowheight > 150){
        $('.site-header').addClass('visible__logo_color');
        $('.site-header__mobile-nav').addClass('visible__logo_color');
      }else{
        $('.site-header').removeClass('visible__logo_color');
        $('.site-header__mobile-nav').removeClass('visible__logo_color');
      }
    }
  },

  DesktopHoverMENU: function(){
    var windowSize = $(window).width();
    var windowheight = $(window).scrollTop();

    if (windowSize >= 768) {
      $(".site-header").mouseenter(function(){

        $(this).addClass('hover_visible__logo_color');
        $('.site-header__mobile-nav').addClass('hover_visible__logo_color');
      });

      $(".site-header").mouseleave(function(){

        $(this).removeClass('hover_visible__logo_color');
        $('.site-header__mobile-nav').removeClass('hover_visible__logo_color');
      });
    }
  },

  //=== Homepage Product Slider ===================================================
  HomeProductSlider: function() {
    //     console.log('Product slider');
    var windowsize = $(window).width();
    if($(".home_product__slider").hasClass("slick-slider")){
      $(".home_product__slider").slick('unslick');
    }
    if (windowsize >= 1024) {
      //       console.log("here");
      $('.home_product__slider').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false
      });
    }
    if (windowsize < 1024 && windowsize >= 768) {
      //         console.log("between");
      $('.home_product__slider').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false
      });
    }
    if (windowsize < 768) {
      //       console.log("this one");
      $('.home_product__slider').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false
      });
    }
  },

  //=== Collection Image Slider ===================================================
  CollectionImageSlider: function() {

    // console.log('CollectionImageSlider');

    var windowsize = $(window).width();
    if (windowsize < 1024) {
      $('.collection-image-slider').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }else{
      $('.collection-image-slider').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1
      });
    }
  },

  //=== Collectionpage Product Slider ===================================================
  CollectionProductSlider: function() {

    var windowsize = $(window).width();
    //     console.log(windowsize);
    if (windowsize >= 1024) {
      $('.template-collection .product-slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false
      });
    }

    if (windowsize < 1024 && windowsize >= 768) {
      $('.template-collection .product-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false
      });
    }

    if (windowsize < 768) {
      $('.template-collection .product-slider').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false
      });
    }

  },


  //=== Product Page Recommendations Slider ===================================================
  ProductRecommendationsSlider: function() {
    var windowsize = $(window).width();
    //     console.log("product "+windowsize);

    if($(".template-product .product-slider").length){
      if (windowsize >= 1024) {
        //         console.log("here");
        $('.template-product .product-slider').slick({
          dots: false,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 2,
          centerMode: false,
          variableWidth: false
        });
      }
      if (windowsize < 1024 && windowsize >= 768) {
        //         console.log("between");
        $('.template-product .product-slider').slick({
          dots: false,
          arrows: false,
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 2,
          centerMode: false,
          variableWidth: false
        });
      }
      if (windowsize < 768) {
        //         console.log("there");
        $('.template-product .product-slider').slick({
          dots: false,
          arrows: false,
          infinite: false,
          speed: 300,
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false
        });
      }
    }
    Theme.MobileheightJS();
  },


  //=== Product Page Recommendations Slider ===================================================
  Productpage: function() {
    var windowsize = $(window).width();
    $( "#product_tags_dropdown a" ).click(function () {
      window.location.href = $(this).attr("href");
    });

    //var h = $(".featured_media[data-index='1']").height() + $(".product_desc").height();
    //$(".product-single__meta-wrap").height(h);
    if($(".product-single__media-group").hasClass("slick-slider")){
      $(".product-single__media-group").slick('unslick');
    }
    if (windowsize < 768) {
      $(".product-single__media-group").slick({
        arrows: true,
        dots: false,
        adaptiveHeight: true,
        infinite:true,
        vertical: true
      });
    }

    $(window).scroll(function() {
      var top = $(window).scrollTop();
      var headerHeight = $('.site-header').outerHeight();
      var leftDivHeight = $('.product-single__media-group').height()-headerHeight;
      var imageGridHeight = $(".legacy-grid__item.product-single__media-group.medium-up--one-half").height() - headerHeight;
      //var DescriptonSticky = headerHeight + top;
//       var DescriptonSticky = top + 750;

      if(window.outerWidth < 1440 ){
      var DescriptonSticky = top + 750;
      }else{
          DescriptonSticky = top + 800;
      }

      // console.log(top)
      if(DescriptonSticky >= imageGridHeight){
        //         console.log('its now remove');

//         console.log(DescriptonSticky, $(".legacy-grid__item.product-single__media-group.medium-up--one-half").height());

        $(".legacy-grid__item.product-single__media-group.medium-up--one-half").css("height", "auto")
        //               console.log(DescriptonSticky+' - '+leftDivHeight);
        //         $('.product-single__meta-wrap').removeClass('right__sticky');
        $('.product-single__meta-wrap').addClass('right__desc');
      }else{
//         $('.product-single__meta-wrap').addClass('right__sticky');
        $('.product-single__meta-wrap').removeClass('right__desc');
      }
      //$(".product-single__meta-wrap").css("top",top);
    })


    $("#pdf_popup").fancybox({
      openEffect  : 'none',
      closeEffect : 'none',
      iframe : {
        preload: false
      }
    });

  },


  //=== Campaigns Product Slider ===================================================
  CampaignsProductSlider: function() {
    //     console.log('Campaigns slider');
    var windowsize = $(window).width();

    if($(".product_image_slider_layout .all-images--cover").hasClass("slick-slider")){
      $(".product_image_slider_layout .all-images--cover").slick('unslick');
    }
    if (windowsize >= 1024) {
      $('.product_image_slider_layout .all-images--cover').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false
      });
    }
    if (windowsize < 1024) {
      $('.product_image_slider_layout .all-images--cover').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false
      });
    }


    if($(".campaigns-full-width-slider").hasClass("slick-slider")){
      $(".campaigns-full-width-slider").slick('unslick');
    }
    if (windowsize >= 768) {
      $('.campaigns-full-width-slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false
      });
    }
    if (windowsize < 768) {
      $('.campaigns-full-width-slider').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false
      });
    }

  },

  //=== Collection Page ===================================================
  EqulHeightProduct: function(a){
    var windowsize = $(window).width();
    if (windowsize > 768) {
      var top = 0;
      var main = $(a);
      var randomClass = ( 'eH' + Math.random() ).replace('.','');
      // console.log('A random class: ' + randomClass); // ?
      main.each( function() {

        var distanceFromTop = $(this).offset().top;
        // console.log('This is ' + distanceFromTop + ' from the top.');

        if ( distanceFromTop > top ) {
          $('.' + randomClass).removeClass(randomClass);
          top = distanceFromTop;
          // console.log('"top" is ' + top + 'px away');
        }

        $(this).addClass(randomClass);

        $(this).css('height','auto');

        var newHeight = (Math.max.apply(null, $('.' + randomClass).map( function() {
          return $(this).outerHeight();
        }).get()));

        $('.' + randomClass).css('height',newHeight);

      }).removeClass(randomClass);
    }
  },
}


$(function (){
  'use strict';
  setTimeout(function(){ Theme.GeneralJS(); }, 300);
  Theme.MenuJS();
  Theme.DesktopHoverMENU();
  Theme.HomeProductSlider();
  Theme.CollectionImageSlider();
  Theme.CollectionProductSlider();
  Theme.EqulHeightProduct('.product_desc > div');
  $( window ).on("load", function() { setTimeout(function(){Theme.ProductRecommendationsSlider(); }, 1500); });
  Theme.Productpage();
  Theme.CampaignsProductSlider();
  $( window ).on("load", function() { setTimeout(function(){ Theme.DesktopheightJS(); }, 1500); });
});

$( window ).resize(function () {
  setTimeout(function(){ Theme.GeneralJS(); }, 300);
  Theme.DesktopHoverMENU();
  Theme.HomeProductSlider();
  Theme.CollectionImageSlider();
  Theme.CollectionProductSlider();
  Theme.EqulHeightProduct('.product_desc > div');
  setTimeout(function(){ Theme.ProductRecommendationsSlider(); }, 1500);
  //$( window ).on("load", function() {setTimeout(function(){ Theme.ProductRecommendationsSlider(); }, 1500); });
  Theme.Productpage();
  Theme.CampaignsProductSlider();
  setTimeout(function(){ Theme.MobileheightJS(); }, 1500);
  //$( window ).on("load", function() { setTimeout(function(){ Theme.MobileheightJS(); }, 1500); });
});

$( window ).scroll(function() {
  Theme.DesktopMENU();
});
